export const CHECKOUT = {
  ADDRESS_CONFIRMATION: 'checkout_address_confirmation',
  ADDRESSES: 'checkout_addresses',
  BILLING_ADDRESS: 'checkout_billing_address',
  CART: 'checkout_cart',
  INSURANCE: 'checkout_insurance',
  PAYMENT_RESULT: 'checkout_payment_result',
  PAYMENT: 'checkout_payment',
  SELF: 'checkout',
  SHIPPING_ADDRESS: 'checkout_shipping_address',
  SERVICES: {
    BOUYGUES: {
      ROOT: 'checkout_services_bouygues_telecom',
      SIGN_UP: 'checkout_services_bouygues_telecom_sign_up',
      AUTH: 'checkout_services_bouygues_telecom_auth',
      PHONELINE_SETUP: 'checkout_services_bouygues_telecom_phoneline_setup',
      NOT_ELIGIBLE: 'checkout_services_bouygues_telecom_not_eligible',
    },
  },
  IN_STORE_SALES: {
    BOUYGUES_TELECOM: {
      SELF: 'checkout_in_store_sales_bouygues_telecom',
      CART: 'checkout_in_store_sales_bouygues_telecom_cart',
      ADDRESSES: 'checkout_in_store_sales_bouygues_telecom_addresses',
      PAYMENT: 'checkout_in_store_sales_bouygues_telecom_payment',
      PAYMENT_RESULT: 'checkout_in_store_sales_bouygues_telecom_payment_result',
    },
  },
  /**  This is used for the modular checkout migration
   * see https://backmarket.atlassian.net/wiki/spaces/BOT/pages/4955996725/Making+checkout+front-end+modular+and+scalable
   * Will be removed once the migration is complete */
  MODULAR_CHECKOUT: {
    SELF: 'checkout_modular_checkout',
    CART: 'checkout_modular_checkout_cart',
  },
}

export const CHECKOUT_STEP_IDS = {
  [CHECKOUT.CART]: 1,
  [CHECKOUT.ADDRESS_CONFIRMATION]: 4,
  [CHECKOUT.SHIPPING_ADDRESS]: 4,
  [CHECKOUT.BILLING_ADDRESS]: 5,
  [CHECKOUT.PAYMENT]: 6,
}
